import { Button, ButtonGroup, Card, DropdownButton, Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Claims, TissueReportSlugs } from "../../../../models";
import { usePermissions } from "../../../../contexts";

export function DistributionLinks() {
    const navigate = useNavigate();
    const { hasPermission } = usePermissions();

    if (!hasPermission(Claims.ViewSurgery)) {
        return null;
    }

    return (
        <div className="distro-header-buttons pe-3 pb-2 d-none d-lg-block">
            <Card className="bg-primary text-white mb-2">
                <Card.Header>Links</Card.Header>
                <Card.Body className="bg-canvas">
                    <ButtonGroup vertical>
                        <a href="/surgery-calendar" target="_blank" rel="noopener noreferrer">
                            <Button variant="outline-primary">Surgery Calendar</Button>
                        </a>
                        <Button variant="outline-primary" onClick={() => navigate("/import-tissue")}>
                            Import Tissue
                        </Button>
                        <DropdownButton
                            as={ButtonGroup}
                            variant="outline-primary"
                            title="Reports"
                            className="distro-header-dropdown"
                            id="distro-reports-dropdown"
                        >
                            <Dropdown.Item
                                onClick={() => navigate(`/tissue-reports/${TissueReportSlugs.ThreeToSixMonthFollowUp}`)}
                            >
                                3-6 Month Post-Operative Follow-Up
                            </Dropdown.Item>
                        </DropdownButton>
                    </ButtonGroup>
                </Card.Body>
            </Card>
        </div>
    );
}
